var _classCallCheck = require("/Users/qw/WebstormProjects/jwc/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/Users/qw/WebstormProjects/jwc/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var request = require('./request');

var Bmob = require('./bmob');

var Error = require('./error');

var pay =
/*#__PURE__*/
function () {
  "use strict";

  function pay() {
    _classCallCheck(this, pay);
  }

  _createClass(pay, [{
    key: "weApp",
    value: function weApp(price, productName, body) {
      var openid = wx.getStorageSync('openid');

      if (!price || !productName || !body || !openid) {
        throw new Error(416);
      } // 传参数金额，名称，描述,openid


      var data = {
        'order_price': price,
        'product_name': productName,
        'body': body,
        'open_id': openid,
        'pay_type': 4
      };
      var route = Bmob._config.parameters.PAY;
      return request(route, 'post', data);
    }
  }]);

  return pay;
}();

module.exports = pay;